// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var GeneralSettingsController = function ($rootScope, $scope, GeneralEmailSettings, gettext, gettextCatalog, PdfDocumentFormat, InvoiceAttachmentDisplayFormats, NormalizedInvoiceReferenceType) {
    $scope.templateCopy = null;
    $scope.selectedInvoiceAttachmentFormat = null;
    $scope.zugFerdFeature = "ZugferdV1";

    $scope.zugferdLink = "https://docu.billwerk.plus/help/transform_en/en/configuration-and-settings/documents/what-is-the-zugferd-standard-and-how-is-it-implemented-.html";

    $scope.availableInvoiceAttachmentFormats = InvoiceAttachmentDisplayFormats.getFormats();

    $scope.normalizedInvoiceReferenceOptions = Object([
        {
            "key": NormalizedInvoiceReferenceType.Off,
            "value": NormalizedInvoiceReferenceType.Off,
            "text": gettext("Off")
        },
        {
            "key": NormalizedInvoiceReferenceType.FinnishReferenceNumber,
            "value": NormalizedInvoiceReferenceType.FinnishReferenceNumber,
            "text": gettext("Finnish Reference Number")
        }
    ]);

    function AddDomainToTemplateSenderAddress() {
        $scope.template.SenderAddress = $scope.template.SenderAddressWithoutDomain + '@' + $scope.template.OwnSenderEmailAddressDomains[0];
        return;
    }
    function RemoveDomainFromTemplateSenderAddress() {
        var email = $scope.template.SenderAddress;
        if (email && email.lastIndexOf("@") > 0)
            $scope.template.SenderAddressWithoutDomain = email.substring(0, email.lastIndexOf("@"));
        return;
    }

    function CheckIfSenderAddressDomainExpired() {
        var email = $scope.template.SenderAddress;
        if (email && email.lastIndexOf("@") > 0 && $scope.template.OwnSenderEmailAddressDomains) {
            var oldDomain = email.substring(email.lastIndexOf("@") + 1, email.length);
            if ($scope.template.OwnSenderEmailAddressDomains[0] !== oldDomain) {
                $scope.isDomainExpired = true;
                $scope.expiredDomain = oldDomain;
                $scope.expiredAddress = email;
                return;
            } 
        }
        $scope.isDomainExpired = false;
        return;
    }

    $scope.template = GeneralEmailSettings.get({}, function() {
        CheckIfSenderAddressDomainExpired();
        RemoveDomainFromTemplateSenderAddress();
        $scope.templateCopy = angular.copy($scope.template);

        $scope.selectedInvoiceAttachmentFormat = $scope.features[$scope.zugFerdFeature]
            ? $scope.template.InvoiceAttachmentFormat
            : PdfDocumentFormat.NoEInvoiceAttachment;
    });

    function saveSettings() {
        if ($scope.features[$scope.zugFerdFeature]) {
            $scope.template.InvoiceAttachmentFormat = $scope.selectedInvoiceAttachmentFormat;
        }

        $scope.template.$update({}, function() {
            $scope.notifySuccess();
            $scope.templateCopy = angular.copy($scope.template);
            RemoveDomainFromTemplateSenderAddress();
        });
    }

    $scope.save = function() {
        if ($scope.template.UseOwnSenderAddress) {
            AddDomainToTemplateSenderAddress();
            RemoveDomainFromTemplateSenderAddress();
        }

        if ($scope.templateCopy && $scope.template.SendDocumentsByEmail !== $scope.templateCopy.SendDocumentsByEmail) {
            $scope.yesNoCancel(gettextCatalog.getString(gettext('Update default dispatch')), gettextCatalog.getString(gettext('Do you want to update the default dispatch for all existing customers as well?')),
                function() {
                    $scope.template.UpdatePropertiesForAll = true;
                    saveSettings();
                },
                function() {
                    $scope.template.UpdatePropertiesForAll = false;
                    saveSettings();
                }
            );
        } else {
            saveSettings();
        }
    };
    
    $scope.extractEmails = function (text) {
        return text.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
    };
};
GeneralSettingsController.$inject = ['$rootScope', '$scope', 'GeneralEmailSettings', 'gettext', 'gettextCatalog', 'PdfDocumentFormat', 'InvoiceAttachmentDisplayFormats', 'NormalizedInvoiceReferenceType'];
